import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { AppConstant, KeyConstant } from "@/const";
import { RequestService } from "@/services";
import { PaginationType } from "@/types/common";
import { ResponseApplicationType } from "@/types/service";

const useApplicationList = () => {
  const { t: getLabel } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getAllApplicationList],
    queryFn: () => RequestService.getAllApplicationList(),
  });

  const { data: applicationList, ...pagination } = data || {};

  const handleApplicationList = [
    {
      value: AppConstant.SELECT_ALL,
      label: getLabel("OBJ_STATUS_REQUEST.all"),
    },
  ].concat(
    applicationList?.map((application: ResponseApplicationType) => {
      return { value: application.uid, label: application.name };
    }) || [],
  );

  return {
    applicationList: handleApplicationList,
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
    refetch,
  };
};

export default useApplicationList;
